import axiosHelper from "../axiosHelper";
import ServiceJobModel from "@/models/ServiceJobModel";

export default class JobsApiHelper {

	async createJob(jwt: string, categoryId: number, componentId: number, operationId: number, groupId?: number, estimationHrs?: number): Promise<boolean | null> {
		try {
			const request = {
				operationId,
				categoryId,
				componentId,
				groupId,
				estimationHrs
			};

			const jobCreateHttpClient = axiosHelper.createInstance(jwt);
			await jobCreateHttpClient.post(`/api/servicejobs`, request);
			return true;
		} catch (e: any) {	
			if (e?.status === 409) {
				console.warn(`Conflict creating service-job (component #${componentId}, operation #${operationId}, category #${categoryId})`);
				return false;
			}
			console.error(`Error creating service-job (component #${componentId}, operation #${operationId}, category #${categoryId})`, e);
			return null;
		}
	}

		/** put request for updating an existing job */
	async updateJob(jwt: string, jobId: number, categoryId: number, componentId: number, operationId: number, groupId?: number, estimationHrs?: number) {
		try {
			const request = {
				id: jobId,					
				operationId,
				categoryId,			
				componentId,
				groupId,
				estimationHrs
			};

			const jobUpdateHttpClient = axiosHelper.createInstance(jwt);
			await jobUpdateHttpClient.put('/api/servicejobs', request);
			return true;
		} catch(e: any) {
			if (e?.status === 409) {
				console.warn(`Conflict updating service-job (jobid #${jobId}, component #${componentId}, operation #${operationId}, category #${categoryId})`);
				return false;
			}

			console.warn(`Error updating service-job (jobid #${jobId}, component #${componentId}, operation #${operationId}, category #${categoryId})`, e);
			return null;
		}
	}

	async getJobByComponentIdAndOperationIdAsync(jwt: string, componentId: number, operationId: number): Promise<ServiceJobModel | null> {
		try {
			const jobCategoriesHttpClient = axiosHelper.createInstance(jwt);
			const jobResponse = await jobCategoriesHttpClient.get(`/api/servicejobs/job/${componentId}/${operationId}`);			
			return new ServiceJobModel(jobResponse.data);
		} catch (e) {			
			console.error(`Error getting service-job by componentId #${componentId} and operationId #${operationId}`, e);
			return null;
		}
	}

	/** get list of all available jobs are related to a component */
	async getJobsByComponentAsync(jwt: string, componentId: number): Promise<Array<ServiceJobModel>> {
		try {
			const jobCategoriesHttpClient = axiosHelper.createInstance(jwt);
			const jobsResponse = await jobCategoriesHttpClient.get(`/api/servicejobs/by-component/${componentId}`);	
			if (!jobsResponse?.data?.length) {
				return [];
			}
			const jobs = jobsResponse.data.map((_: any) => new ServiceJobModel(_));
			return jobs;
		} catch (e) {			
			console.error(`Error getting service-jobs by componentId #${componentId}`, e);
			return [];
		}
	}
}